import Vue from "vue";
import VueRouter from "vue-router";
import Meta from "vue-meta";
import Home from "../views/Home.vue";

Vue.use(VueRouter);
Vue.use(Meta);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/group",
    component: () => import("../views/group/MainTemplate.vue"),
    redirect: "/group/home/carousel",
    children: [
      {
        path: "home",
        component: () => import("../views/group/Home.vue"),
        children: [
          {
            name: "/group/home/carousel",
            path: "carousel",
            component: () => import("../views/group/Home_Carousel.vue"),
            meta: {
              title: "首頁輪播圖",
            },
          },
          {
            name: "/group/home/news",
            path: "news",
            component: () => import("../views/group/News.vue"),
            meta: {
              title: "最新消息",
            },
          },
        ],
      },
      {
        name: "/group/news/album",
        path: "news/album/:id",
        component: () => import("../views/group/News_Album.vue"),
        meta: {
          title: "活動花絮",
        },
      },
      {
        name: "/group/dm-download",
        path: "dm-download",
        component: () => import("../views/group/Dm_Download.vue"),
        meta: {
          title: "服務項目DM下載",
        },
      },
      {
        name: "/group/website-link",
        path: "website-link",
        component: () => import("../views/group/Website_Link.vue"),
        meta: {
          title: "好站連結",
        },
      },
      {
        name: "/group/contactUs",
        path: "contactUs",
        component: () => import("../views/group/ContactUs.vue"),
        meta: {
          title: "聯絡我們",
        },
      },
    ],
  },
  {
    path: "/insurance-broker",
    component: () => import("../views/insurance-broker/MainTemplate.vue"),
    redirect: "/insurance-broker/home/star",
    children: [
      {
        path: "home",
        component: () => import("../views/insurance-broker/Home.vue"),
        children: [
          {
            name: "/insurance-broker/home/news",
            path: "news",
            component: () => import("../views/insurance-broker/News.vue"),
            meta: {
              title: "最新消息",
            },
          },
          {
            name: "/insurance-broker/home/star",
            path: "star",
            component: () => import("../views/insurance-broker/Home_Star.vue"),
            meta: {
              title: "金豐之星",
            },
          },
        ],
      },
      {
        path: "about-us",
        component: () => import("../views/insurance-broker/AboutUs.vue"),
        children: [
          {
            name: "/insurance-broker/about-us/background",
            path: "background",
            component: () => import("../views/insurance-broker/AboutUs_Background.vue"),
            meta: {
              title: "公司背景",
            },
          },
          {
            name: "/insurance-broker/about-us/increase",
            path: "rank",
            component: () => import("../views/insurance-broker/AboutUs_Increase.vue"),
            meta: {
              title: "增員天地",
            },
          },
        ],
      },
      {
        path: "advantage-product",
        component: () => import("../views/insurance-broker/AdvantageProduct.vue"),
        children: [
          {
            name: "/insurance-broker/advantage-product/retail",
            path: "retail",
            component: () => import("../views/insurance-broker/AdvantageProduct_Main.vue"),
            meta: {
              title: "退休規劃",
            },
          },
          {
            name: "/insurance-broker/advantage-product/inherit",
            path: "inherit",
            component: () => import("../views/insurance-broker/AdvantageProduct_Main.vue"),
            meta: {
              title: "財富傳承",
            },
          },
          {
            name: "/insurance-broker/advantage-product/health",
            path: "health",
            component: () => import("../views/insurance-broker/AdvantageProduct_Main.vue"),
            meta: {
              title: "醫療照護",
            },
          },
          {
            name: "/insurance-broker/advantage-product/business",
            path: "business",
            component: () => import("../views/insurance-broker/AdvantageProduct_Main.vue"),
            meta: {
              title: "企業保險",
            },
          },
          {
            name: "/insurance-broker/advantage-product/labor",
            path: "labor",
            component: () => import("../views/insurance-broker/AdvantageProduct_Main.vue"),
            meta: {
              title: "職災保險",
            },
          },
        ],
      },
      {
        path: "training-system",
        component: () => import("../views/insurance-broker/TrainingSystem.vue"),
        children: [
          {
            name: "/insurance-broker/training-system/basic",
            path: "basic",
            component: () => import("../views/insurance-broker/TrainingSystem_Main.vue"),
            meta: {
              title: "基本培訓",
            },
          },
          {
            name: "/insurance-broker/training-system/professional",
            path: "professional",
            component: () => import("../views/insurance-broker/TrainingSystem_Main.vue"),
            meta: {
              title: "專業行銷",
            },
          },
          {
            name: "/insurance-broker/training-system/video",
            path: "video",
            component: () => import("../views/insurance-broker/TrainingSystem_Main.vue"),
            meta: {
              title: "視訊直播教學",
            },
          },
        ],
      },
      {
        path: "honor-system",
        component: () => import("../views/insurance-broker/HonorSystem.vue"),
        children: [
          {
            name: "/insurance-broker/honor-system/system",
            path: "system",
            component: () => import("../views/insurance-broker/HonorSystem_System.vue"),
            meta: {
              title: "榮譽獎勵辦法",
            },
          },
          {
            name: "/insurance-broker/honor-system/rank",
            path: "rank",
            component: () => import("../views/insurance-broker/HonorSystem_Rank.vue"),
            children: [
              {
                name: "/insurance-broker/honor-system/rank/month",
                path: "month",
                component: () => import("../views/insurance-broker/HonorSystem_Rank_Month.vue"),
                children: [
                  {
                    name: "/insurance-broker/honor-system/rank/month/case-number",
                    path: "case-number",
                    component: () => import("../views/insurance-broker/HonorSystem_Rank_Month_CaseNumber.vue"),
                    meta: {
                      title: "件數高手",
                    },
                  },
                  {
                    name: "/insurance-broker/honor-system/rank/month/performance",
                    path: "performance",
                    component: () => import("../views/insurance-broker/HonorSystem_Rank_Month_Performance.vue"),
                    meta: {
                      title: "業績高手",
                    },
                  },
                  {
                    name: "/insurance-broker/honor-system/rank/month/office",
                    path: "office",
                    component: () => import("../views/insurance-broker/HonorSystem_Rank_Month_Office.vue"),
                    meta: {
                      title: "榮譽營業處",
                    },
                  },
                ],
              },
              {
                name: "/insurance-broker/honor-system/rank/year",
                path: "year",
                component: () => import("../views/insurance-broker/HonorSystem_Rank_Year.vue"),
                meta: {
                  title: "年度排行榜",
                },
              },
              {
                name: "/insurance-broker/honor-system/rank/history",
                path: "history",
                component: () => import("../views/insurance-broker/HonorSystem_Rank_History.vue"),
                meta: {
                  title: "歷年榮譽榜",
                },
              },
            ],
          },
          {
            name: "/insurance-broker/honor-system/travel",
            path: "travel",
            component: () => import("../views/insurance-broker/HonorSystem_Travel.vue"),
            meta: {
              title: "海外旅遊",
            },
          },
          {
            name: "/insurance-broker/honor-system/album",
            path: "album/:id",
            component: () => import("../views/insurance-broker/Activity_Album.vue"),
            meta: {
              title: "活動花絮",
            },
          },
        ],
      },
      {
        path: "activity",
        component: () => import("../views/insurance-broker/Activity.vue"),
        children: [
          {
            name: "/insurance-broker/activity/travel",
            path: "travel",
            component: () => import("../views/insurance-broker/Activity_Main.vue"),
            meta: {
              title: "海外旅遊",
            },
            // children: [
            //   {
            //     name: '/insurance-broker/activity/travel/album',
            //     path: 'album',
            //     component: () => import('../views/insurance-broker/Activity_Album.vue'),
            //   },
            // ],
          },
          {
            name: "/insurance-broker/activity/party",
            path: "party",
            component: () => import("../views/insurance-broker/Activity_Main.vue"),
            meta: {
              title: "尾牙春酒",
            },
            // children: [
            //   {
            //     name: '/insurance-broker/activity/party/album',
            //     path: ':id',
            //     component: () => import('../views/insurance-broker/Activity_Album.vue'),
            //   },
            // ],
          },
          {
            name: "/insurance-broker/activity/charity",
            path: "charity",
            component: () => import("../views/insurance-broker/Activity_Main.vue"),
            meta: {
              title: "公益活動",
            },
            // children: [
            //   {
            //     name: '/insurance-broker/activity/charity/album',
            //     path: ':id',
            //     component: () => import('../views/insurance-broker/Activity_Album.vue'),
            //   },
            // ],
          },
          {
            name: "/insurance-broker/activity/training",
            path: "training",
            component: () => import("../views/insurance-broker/Activity_Main.vue"),
            meta: {
              title: "培訓活動",
            },
            // children: [
            //   {
            //     name: '/insurance-broker/activity/charity/album',
            //     path: ':id',
            //     component: () => import('../views/insurance-broker/Activity_Album.vue'),
            //   },
            // ],
          },
          {
            name: "/insurance-broker/activity/album",
            path: "album/:id",
            component: () => import("../views/insurance-broker/Activity_Album.vue"),
            meta: {
              title: "活動花絮",
            },
          },
        ],
      },
      {
        name: "/insurance-broker/law-compliance",
        path: "law-compliance",
        component: () => import("../views/insurance-broker/LawCompliance.vue"),
        meta: {
          title: "法令遵循專區",
        },
      },
    ],
  },

  {
    path: "/certificate",
    component: () => import("../views/certificate/MainTemplate.vue"),
    redirect: "/certificate/home/News",
    children: [
      {
        path: "home",
        component: () => import("../views/certificate/Home.vue"),
        children: [
          {
            name: "/certificate/home/News",
            path: "news",
            component: () => import("../views/certificate/News.vue"),
            meta: {
              title: "訊息管理",
            },
          },
          {
            name: "/certificate/home/Course",
            path: "course",
            component: () => import("../views/certificate/Course.vue"),
            meta: {
              title: "課程上架",
            },
          },
          {
            name: "/certificate/home/usersManager",
            path: "usersManager",
            component: () => import("../views/certificate/UsersManager.vue"),
            meta: {
              title: "會員管理",
            },
          },
          {
            name: "/certificate/home/UserInfo",
            path: "userInfo/:userId",
            component: () => import("../views/certificate/UserInfo.vue"),
            meta: {
              title: "會員資訊",
            },
          },
          {
            name: "/certificate/home/trainAndReTrainSetting",
            path: "trainAndReTrainSetting/",
            component: () => import("../views/certificate/TrainAndReTrainSetting.vue"),
            meta: {
              title: "培訓&複訓設定",
            },
          },
          {
            name: "/certificate/home/examSessionManager",
            path: "examSessionManager",
            component: () => import("../views/certificate/ExamSessionManager.vue"),
            meta: {
              title: "場次管理",
            },
          },
          {
            name: "/certificate/home/examLocationManager",
            path: "examLocationManager",
            component: () => import("../views/certificate/ExamLocationManager.vue"),
            meta: {
              title: "前台場地管理",
            },
          },
          {
            name: "/certificate/home/register",
            path: "register",
            component: () => import("../views/certificate/Register.vue"),
            meta: {
              title: "考證報名",
            },
          },
          {
            name: "/certificate/home/lecturerManager",
            path: "lecturerManager",
            component: () => import("../views/certificate/LecturerManager.vue"),
            meta: {
              title: "講師管理",
            },
          },
          {
            name: "/certificate/home/lecturerInfo",
            path: "lecturerInfo/:id",
            component: () => import("../views/certificate/LecturerInfo.vue"),
            meta: {
              title: "講師資訊",
            },
          },
        ],
      },
    ],
  },
  {
    path: "/error",
    name: "error",
    component: () => import("../views/Error.vue"),
  },
  {
    path: "*",
    redirect: "error",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
